import React, {Dispatch, FC, SetStateAction} from 'react';
import {Button, Form} from 'react-bootstrap';
import {EnvSetup} from 'enums/Envs';
import {AbuseWord, abuseWordsService} from 'services/abuseWordsService';
import {ModerationHint} from 'components';

type Props = {
    word: AbuseWord;
    env: EnvSetup;
    testText: string;
    setTestText: Dispatch<SetStateAction<string>>;
    testResult: string;
    setTestResult: Dispatch<SetStateAction<string>>;
};

export const AbuseWordModalTestSection: FC<Props> = ({
    word,
    env,
    testText,
    setTestText,
    testResult,
    setTestResult,
}) => (
    <div className="border rounded-3 p-3 h-100 d-flex flex-column bg-white shadow-sm">
        <Form.Label className="fw-medium">Быстрый тест</Form.Label>
        <Form.Text muted className="d-block mb-2">
            Проверяет текущий паттерн на произвольной строке (без запроса к API превью).
        </Form.Text>
        <Form.Group className="flex-grow-1 d-flex flex-column mb-0" controlId="abuse-word-test-text">
            <Form.Control
                as="textarea"
                className="flex-grow-1 font-monospace"
                style={{minHeight: '6rem'}}
                placeholder="Био профиля, сообщение и т.д."
                value={testText}
                onChange={e => {
                    setTestText(e.target.value);
                    setTestResult('');
                }}
            />
            <div className="d-flex flex-wrap gap-2 mt-2">
                <Button variant="primary" size="sm" onClick={() => {
                    abuseWordsService.test(testText, word, env).then(r => setTestResult(r ?? ''))
                }}>
                    Протестировать
                </Button>
            </div>
        </Form.Group>
        <div className="mt-3 pt-3 border-top flex-shrink-0" style={{minHeight: '3.5rem'}}>
            {testResult
                ? <ModerationHint className="alert-warning fw-normal mb-0 py-2 small">{testResult}</ModerationHint>
                : <span className="text-muted small">Результат теста появится здесь.</span>}
        </div>
    </div>
);
